import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { DetalleComponent } from './components/detalle/detalle.component';
import { DetalleRuntComponent } from './components/detalle-runt/detalle-runt.component';

import { DetalleService } from './services/detalle.service';
import { DetalleInternoService } from './services/detalle-interno.service';
import { DetalleSolicitudResolver } from './services/detalle-solicitud-resolver.service';
import { DetalleSolicitudInternoResolver } from './services/detalle-solicitud-interno-resolver.service';

import { TokenInterceptor } from './interceptors/token.interceptor';
import { RequestInterceptor } from './interceptors/request.interceptor';

import { SharedModule } from '../shared/shared.module';

import { AppRoutingModule } from '../app-routing.module';

@NgModule({
  declarations: [
    DetalleComponent,
    DetalleRuntComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    SharedModule
  ],
  providers: [
    DetalleService,
    DetalleSolicitudResolver,
    DetalleInternoService,
    DetalleSolicitudInternoResolver,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
  ],
})
export class CoreModule { }



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/core/core.module.ts